import {
  Component,
  Input,
  CUSTOM_ELEMENTS_SCHEMA,
  Output,
  EventEmitter,
} from '@angular/core';

import { LeafAngularWrapper } from '../leaf-angular-wrapper';

import type { LeafRadioFieldItem } from '@cigna/leaf-web/lib/wc';
import '@cigna/leaf-web/lib/wc/components/radio-field-item/radio-field-item';

@Component({
  selector: 'cigna-leaf-radio-field-item',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <leaf-radio-field-item
      [ariaDescribedBy]="ariaDescribedBy"
      [checked]="checked"
      [disabled]="disabled"
      [isError]="isError"
      [isSuccess]="isSuccess"
      [label]="label"
      [name]="name"
      [required]="required"
      [value]="value"
      [isOptional]="isOptional"
      [optionalText]="optionalText"
      (input)="change.emit($event.target.checked)"
      (click)="handleClick($event)"
    >
    </leaf-radio-field-item>
  `,
})
export class CignaLeafRadioFieldItemComponent extends LeafAngularWrapper {
  @Input() ariaDescribedBy: LeafRadioFieldItem['ariaDescribedBy'];
  @Input() checked: LeafRadioFieldItem['checked'];
  @Input() disabled: LeafRadioFieldItem['disabled'];

  // weird bug with fieldId where it does not autogenerate id if we pass undefined to input
  // so for now removing property. in  most cases you don't need to set explicit fieldId
  // @Input() fieldId: LeafRadioFieldItem['fieldId'];

  @Input() isError: LeafRadioFieldItem['isError'];
  @Input() isSuccess: LeafRadioFieldItem['isSuccess'];
  @Input() label: LeafRadioFieldItem['label'] = '';
  @Input() name: LeafRadioFieldItem['name'];
  @Input() required: LeafRadioFieldItem['required'];
  @Input() value: LeafRadioFieldItem['value'];
  @Input() isOptional: LeafRadioFieldItem['isOptional'] = false;
  @Input() optionalText: LeafRadioFieldItem['optionalText'];

  /**
   * ********
   * CUSTOM ANGULAR PROPERTIES
   */
  @Output() change = new EventEmitter<boolean>();
  @Output() itemSelected = new EventEmitter<MouseEvent>();

  handleClick(event: MouseEvent) {
    this.itemSelected.emit(event);
  }
}
